import {
    SET_IMPERSONATING_STATE_KEY,
    GET_TRUELAYER_URL,
    GET_OFFERS,
    SET_CUSTOMER_STATUS,
    SET_NEW_STATE_KEY,
    SET_APPLICATION_DATA
} from './lendingAPI.actions';

const initialState = {
    context: { data: {} },
    profile: { data: {} },
    application: { data: {} },
    offers: { data: {} },
    previous_covid_loans: { data: {} },
    stateKey: null,
    impersonatingStateKey: null,
    customerStatus: null
};

const lendingAPIReducers = [
    setApplicationData,
    setNewStateKeyReducer,
    setStateKeyReducer,
    setImpersonatingStateKeyReducer,
    setCustomerStatusReducer,
    lendingAPIReducerFactory('GET_CONTEXT', 'context'),
    lendingAPIReducerFactory('GET_APPLICATION', 'application'),
    lendingAPIReducerFactory(GET_OFFERS, 'offers'),
    lendingAPIReducerFactory('GET_CUSTOMER_STATE', 'customer_state'),
    lendingAPIReducerFactory('GET_CUSTOMER_STATE_EDGE', 'customer_state_edge'),
    lendingAPIReducerFactory('POST_REQUEST_LOGIN_LINK', 'login_link'),
    lendingAPIReducerFactory('POST_THREATMETRIX', 'threatmetrix'),
    lendingAPIReducerFactory('GET_PROFILE', 'profile'),
    lendingAPIReducerFactory(
        'GET_FORMAL_INDICATIVE_OFFERS',
        'formal_indicative_offers'
    ),
    lendingAPIReducerFactory(GET_TRUELAYER_URL, 'truelayer')
];

export default function lendingAPIReducer(state = initialState, action) {
    return lendingAPIReducers.reduce(
        (prevState, reducer) => reducer(prevState, action),
        state
    );
}

function setNewStateKeyReducer(state, action) {
    switch (action.type) {
        case SET_NEW_STATE_KEY:
            return {
                ...state,
                stateKey: action.stateKey
            };
        default:
            return state;
    }
}

function setApplicationData(state, action) {
    switch (action.type) {
        case SET_APPLICATION_DATA:
            return {
                ...state,
                application: {
                    pending: false,
                    data: action.applicationData,
                    error: null
                }
            };
        default:
            return state;
    }
}

function setStateKeyReducer(state, action) {
    switch (action.type) {
        case 'api/GET_CONTEXT [success]':
            return {
                ...state,
                stateKey: action.payload.state_key
            };
        default:
            return state;
    }
}

function setImpersonatingStateKeyReducer(state, action) {
    switch (action.type) {
        case SET_IMPERSONATING_STATE_KEY:
            return {
                ...state,
                impersonatingStateKey: action.stateKey
            };
        default:
            return state;
    }
}

function setCustomerStatusReducer(state, action) {
    switch (action.type) {
        case SET_CUSTOMER_STATUS:
            return {
                ...state,
                customerStatus: action.customerStatus
            };
        default:
            return state;
    }
}

function lendingAPIReducerFactory(actionName, stateName) {
    return function (state, action) {
        switch (action.type) {
            case `api/${actionName} [pending]`:
                return {
                    ...state,
                    [stateName]: {
                        ...state[stateName],
                        pending: true
                    }
                };
            case `api/${actionName} [success]`:
                return {
                    ...state,
                    [stateName]: {
                        pending: false,
                        data: action.payload,
                        error: null
                    }
                };
            case `api/${actionName} [fail]`:
                return {
                    ...state,
                    [stateName]: {
                        pending: false,
                        data: null,
                        error: action.payload
                    }
                };
            default:
                return state;
        }
    };
}
